import { defineTemplate } from '../../../utils';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/templates`;

export const disneyBinge = defineTemplate({
  mode: 'legacy',
  id: 'binge',
  clientId: 'DISNEY',
  handlerKey: 'DISNEY',
  title: 'Maratonear',
  disabled: true,
  hiddenFromUI: true,
  thumbnail: {
    url: `${BASE}/thumbnails/maratonear.png`,
    optimizedUrl: `${BASE}/thumbnails/optimized/maratonear.png`,
    hoverVideo: `${BASE}/previews/para_maratonear.mp4`,

    aspectRatio: 'vertical'
  },
  formFields: []
});
